var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockIcon = function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e71019",
    d: "M0 0h44v44H0z",
    "data-name": "Rectangle 108"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e71019",
    clipPath: "url(#clock-icon_svg__a)",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.071-.067A22.089 22.089 0 1 1-.067 21.969 22.124 22.124 0 0 1 22.071-.067m-.048 42.706A20.616 20.616 0 1 0 1.406 22.054a20.66 20.66 0 0 0 20.617 20.585",
    "data-name": "Path 248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.286 14.389c0-1.265-.054-2.535.035-3.794.026-.367.462-.705.71-1.057.242.36.685.714.695 1.08.063 2.448 0 4.9.065 7.346a1.7 1.7 0 0 0 .695 1.173 3.38 3.38 0 0 1 1.7 3.395 3.275 3.275 0 0 1-2.569 2.642 3.36 3.36 0 0 1-3.495-1.723 1.58 1.58 0 0 0-1.074-.661c-1.711-.07-3.43.015-5.14-.065-.4-.019-.786-.46-1.178-.707.395-.244.78-.678 1.186-.7 1.629-.081 3.264-.054 4.9-.024.657.012 1.139-.052 1.432-.786a2.13 2.13 0 0 1 1.048-1.134c.995-.373 1.037-1.072 1-1.925-.041-1.019-.01-2.041-.009-3.061m2.454 7.685a1.721 1.721 0 1 0-1.744 1.667 1.73 1.73 0 0 0 1.744-1.667",
    "data-name": "Path 249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.258 5.317c-.61.429-.957.858-1.238.819a1.22 1.22 0 0 1-.759-.826c-.043-.192.444-.7.71-.713.319-.016.657.343 1.287.719",
    "data-name": "Path 250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.616 22.03c-.634.394-1 .8-1.284.75a1.2 1.2 0 0 1-.73-.837c-.035-.195.472-.686.736-.687.325 0 .652.37 1.279.774",
    "data-name": "Path 251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.66 20.783c.406.609.782.929.782 1.249 0 .267-.484.78-.676.746a1.22 1.22 0 0 1-.865-.719c-.053-.279.361-.647.76-1.276",
    "data-name": "Path 252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.258 38.662c-.609.4-.93.78-1.25.779-.266 0-.779-.485-.744-.677a1.22 1.22 0 0 1 .72-.864c.28-.053.647.363 1.274.762",
    "data-name": "Path 253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.216 11.482c-.388-.633-.789-1-.735-1.276a1.2 1.2 0 0 1 .844-.722c.193-.034.676.477.677.744 0 .318-.375.637-.786 1.254",
    "data-name": "Path 254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.561 10.176c.644-.368 1.022-.759 1.3-.7a1.21 1.21 0 0 1 .7.87c.028.193-.5.66-.768.652-.319-.01-.626-.4-1.227-.825",
    "data-name": "Path 255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.322 35.035c-.44-.594-.87-.922-.841-1.2a1.2 1.2 0 0 1 .777-.793c.2-.049.721.415.745.68.028.317-.321.668-.68 1.317",
    "data-name": "Path 256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.041 33.825c-.634.387-.968.75-1.284.736-.268-.012-.759-.514-.718-.705a1.2 1.2 0 0 1 .755-.817c.279-.043.629.372 1.247.786",
    "data-name": "Path 257"
  })))));
};
export default SvgClockIcon;